import styled from "styled-components";

export const MainCard = styled.div`
  pre {
    font-style: normal;
    font-weight: 325;
    font-size: 13px;
    line-height: 20px;
  }
  padding: 0px 16px;
  background: #ffffff;
  border: 1px solid #d0d2dd;
  border-radius: 8px;
  overflow-x: auto;
`;

const BoldFontFamily = styled.span`
  font-family: Ringside Regular-Bold;
  font-style: normal;
  font-weight: 400;
`;

export const HeaderTitle = styled(BoldFontFamily)`
  font-size: 16px;
  line-height: 24px;
  color: #4e5ba6;
  width: 100%;
  display: inline-flex;
  justify-content: center;
`;

export const HeaderSubTitle = styled(BoldFontFamily)`
  font-size: 14px;
  line-height: 20px;
  color: #4e5ba6;
  width: 100%;
  display: inline-flex;
  justify-content: center;
`;

export const TipWrapper = styled.div<{
  color: string;
}>`
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.color};
`;

export const CheckTypeWrapper = styled.span`
  font-family: Ringside Regular-Book;
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 20px;
  color: #4e5ba6;
`;

export const BackButtonTextWrapper = styled(BoldFontFamily)`
  font-size: 18px;
  line-height: 24px;
  color: #4e5ba6;
`;

export const BackButtonWrapper = styled.div`
  display: flex;
  padding: 24px 16px;
  gap: 19px;
  align-items: center;
`;

export const CheckCardWrapper = styled.div`
  margin: 0px 16px;
`;

export const CheckInformationWrapper = styled.div`
  margin-bottom: 16px;
`;
